// extracted by mini-css-extract-plugin
module.exports = {"address_icon":"AddressLink_address_icon__35YUy","address_link":"AddressLink_address_link__GJeFs"};